// Shared tag taxonomy — mirrors backend scoring.py.
// Single source of truth for tag chip styling (was duplicated in
// NumberSearch.jsx and Decodes.jsx with drifting contents).

export const SATANIC_TAGS = new Set([
  "satanic","satan","lucifer","devil","baphomet","beast","antichrist",
  "demonic","evil","hell","666","pentagram","hexagram","kabbalah",
]);

export const HUBBARD_TAGS = new Set([
  "jesuit","vatican","pope","papal","freemason","masonic","lodge",
  "saturn","black_sun","eclipse","ritual_sacrifice","ritual","sacrifice",
  "sports_ritual","lockstep","coronavirus_op","scripted","agenda","occult",
  "talmud","zionist","rothschild","blackcube","illusion111","dyr","astrology",
]);

export const HOT_TAGS = new Set(["death", "kill", "murder"]);

export function tagClass(t) {
  const tl = (t || "").toLowerCase();
  if (SATANIC_TAGS.has(tl)) return "tag tag-satanic";
  if (HUBBARD_TAGS.has(tl) || HOT_TAGS.has(tl)) return "tag tag-hot";
  return "tag";
}
